import React from "react";

import { Container } from "./styles";

function OfflineSplash() {
  return (
    <Container>
      <p>
        Ops... parece que você está <strong>sem internet</strong> no momento.
      </p>
    </Container>
  );
}

export default OfflineSplash;
